import React from 'react';
import Preloader from './components/Preloader';
import Navbar from './components/Navbar';
import HeroSlider from './components/HeroSlider';
import WhoWeAreSection from './components/WhoWeAreSection';
import ImageFeatureSection from './components/ImageFeatureSection';
import ServicesSection from './components/ServicesSection';
import TestimonialsSection from './components/TestimonialsSection';
import WorkProcessSection from './components/WorkProcessSection';
import ClientsSection from './components/ClientsSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App font-geist">
      <Preloader />
      <Navbar />
      <main>
        <HeroSlider />
        <WhoWeAreSection />
        <ImageFeatureSection />
        <ServicesSection />
        {/* <TestimonialsSection /> */}
        {/* When we include this back we need to change Wow bg color back to white (delete bg-gray-50 dark:bg-gray-900) */}
        <WorkProcessSection />
        {/* <ClientsSection /> */}
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
